var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBasket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7273 14.8571V18.2857H24V20.5714H20.7273V24H18.5455V20.5714H15.2727V18.2857H18.5455V14.8571H20.7273ZM12 12.5714C10.8 12.5714 9.81819 13.6 9.81819 14.8571C9.81819 16.1143 10.8 17.1429 12 17.1429C13.2 17.1429 14.1818 16.1143 14.1818 14.8571C14.1818 13.6 13.2 12.5714 12 12.5714ZM13.4727 21.7143H4.90909C3.90545 21.7143 3.06545 21.0057 2.81455 20.0457L0.0436363 9.45142C-3.88726e-08 9.34855 0 9.24573 0 9.14285C0 8.51427 0.490909 8.00002 1.09091 8.00002H6.31638L11.0945 0.514286C11.3018 0.182857 11.6509 0 12 0C12.3491 0 12.6982 0.182857 12.9055 0.502857L17.6836 8.00002H22.9091C23.5091 8.00002 24 8.51427 24 9.14285L23.9673 9.45142L22.9091 13.4972C22.2873 13.1428 21.5891 12.8457 20.8582 12.6971L21.4909 10.2857H2.52L4.90909 19.4285H13.0909C13.0909 20.2286 13.2327 20.9943 13.4727 21.7143ZM8.94548 8.00002H15.0545L12 3.2L8.94548 8.00002Z",
    fill: "#495E57"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasket);
export default __webpack_public_path__ + "static/media/basket.81475133c170e74acf8a062e6d36bfc7.svg";
export { ForwardRef as ReactComponent };